import _ from "lodash";
import chatService from "../../services/chat";
import firebase from "@/services/firebase";
import Utils from "../../mixins/Utils";
 import Vue from 'vue';
import { LOG_ACTIVITY_TYPE, LAST_TIME_LOG_REF_PATH} from "../../constants/chat";
const vueAppChatUrl =   window.configs && window.configs.VUE_APP_CHAT_URL !== ""
? window.configs.VUE_APP_ROUTE_BASE_URL: process.env.VUE_APP_ROUTE_BASE_URL;
const chat = {
	namespaced: true,
  state: {
    conversations: [],
    currentConversation: null,
    pendingMsgs: {},
    userId: null,
    numberUnreadConversations: 0,
    chatSettings: null,
    isReachChatIcon: false
  },
  actions: {
    getConversations(store, userId) {
      return new Promise((resolve, reject) => {
        chatService.getConversations({offset: 0, limit: 100}).then(res => {
          store.commit('SET_CONVERSATIONS', res);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      });
    },
    addPendingMsg(store, {msg, path}) {
      store.commit('ADD_PENDING_MSGS', {msg, path})
    },
    removePendingMsg(store, {msg, path}) {
      store.commit('REMOVE_MSG', {msg, path})
    },
    setCurrentConversation(store, conversation) {
      store.commit('SET_CURRENT_CONVERSATION', conversation)
    },
    sendPendingMsgs(store, {conversationId, path}) {
      const pendingMsgs = store.getters.pendingMsgs[path];
      if (pendingMsgs) {
        const sendSuccess = []
        pendingMsgs.forEach(mess => {
          const msg = _.cloneDeep(mess);
          msg.sentAt = new Date().getTime();

          let newData = firebase
            .database()
            .ref(path)
            .push();
          newData.set(msg);
          chatService.logTheLastTimeOfMessage(`${LAST_TIME_LOG_REF_PATH}/${conversationId}`,  msg.sentAt);

          sendSuccess.push(mess);
          

          // Log activity
          const logMsgBody =  {
            idConversation: store.getters.currentConversation.id.toString(),
            idUser: JSON.parse(localStorage.getItem("user")).pkCrf,
            nbMessages: 1,
            typeAction: LOG_ACTIVITY_TYPE.NEW_MESSAGE,
          }
          chatService.logChatActivity(logMsgBody).then((res)=> {
            if(res && !res.success) {
        let message = res.error;
        switch (res.error){
       case 'err_logs_activity_chat_not_found': {
         message = this.$t('err_logs_activity_chat_not_found');
         break;
       }

       case 'err_invalid_date_time_create_message': {
         message = this.$t('err_invalid_date_time_create_message');
         break;
       }
       }
        //  Utils.methods.callToaster(message);
         Vue.toasted.show(message, {
          position: "top-center",
          duration: 3500,
          action: [],
          closeOnSwipe: true,
          color: "#9b3c6e",
          className: "notif-class",
        });
      
       }
           
         }).catch((err)=> {
         let message = err.message ||err;
          switch (err.code ||err){
            case 'err_logs_activity_chat_not_found': {
              message = this.$t('err_logs_activity_chat_not_found');
              break;
            }
     
            case 'err_invalid_date_time_create_message': {
              message = this.$t('err_invalid_date_time_create_message');
              break;
            }
            }
            Vue.toasted.show(message, {
              position: "top-center",
              duration: 3500,
              action: [],
              closeOnSwipe: true,
              color: "#9b3c6e",
              className: "notif-class",
            });         });

          // Upload Image
          if (msg.files.length) {
            const newFiles = [];
            msg.files.forEach(item => {
              const data = new FormData();
              data.append('conversation_id', msg.conversationId);
              data.append('member_id', msg.memberId);
              data.append('fileUpload', item.file);

              chatService.uploadFile(data).then(res => {
                delete res.preview;
                newFiles.push({
                  ...item,
                  filePath: `${vueAppChatUrl}/api/chat/file-upload/${res.id}`
                })
                firebase.database().ref(`${path}/${newData.key}/files`).set(newFiles)
              chatService.logTheLastTimeOfMessage(`${LAST_TIME_LOG_REF_PATH}/${conversationId}`, new Date().getTime());

              }).catch((err)=> {
                let message = err.message ||err;
                switch(err.code ||err) {
                  case 'file.not.found': {
                    message =  this.$t('file_not_found');
                    break;
                  }
                  case 'unsupported.file.format': {
                    message =  this.$t('unsupported_file_format');
                    break;
                  }
                  
                 }

                 Vue.toasted.show(message, {
                  position: "top-center",
                  duration: 3500,
                  action: [],
                  closeOnSwipe: true,
                  color: "#9b3c6e",
                  className: "notif-class",
                });
                 
              })
            })
          }
        })
        sendSuccess.forEach(mess => {
          store.dispatch('removePendingMsg', {msg: mess, path: path});
        })
      }
    },
    getNumberUnreadConversation(store,userId) {
      return new Promise((resolve, reject) => {
        chatService.getUnreadConversationCount( userId).then(res => {
          store.commit('SET_NUMBER_UNREAD_MESSAGE', res.numberOfUnreadConversation);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      });
    },
    getChatSettings(store) {
      chatService.getSettings().then(res => {
        store.commit('SET_CHAT_SETTINGS', res)
      })
    }
  },
  mutations: {
    SET_CONVERSATIONS: (state, conversations) => {
      state.conversations = conversations;
    },
    SET_CURRENT_CONVERSATION: (state, conversation) => {
      state.currentConversation = conversation;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    ADD_PENDING_MSGS: (state, {msg, path}) => {
      if (!state.pendingMsgs[path]) {
        state.pendingMsgs[path] = [];
      }
      state.pendingMsgs[path].push(msg);
    },
    REMOVE_MSG: (state, {msg, path}) => {
      const msgIndex = _.findIndex(state.pendingMsgs[path], msg);
      if (msgIndex !== -1) {
          state.pendingMsgs[path].splice(msgIndex, 1);
      }
      if (!state.pendingMsgs[path].length) {
        delete state.pendingMsgs[path];
      }
    },
    SET_NUMBER_UNREAD_MESSAGE:(state,numberUnreadConversations) => {
      state.numberUnreadConversations =numberUnreadConversations;
    },
    SET_CHAT_SETTINGS: (state, settings) => {
      state.chatSettings = settings;
    },
    SET_REACH_CHAT_ICON: (state, isReachChatIcon) => {
      state.isReachChatIcon = isReachChatIcon;
    }
  },
  getters: {
    conversations: (state) => state.conversations,
    pendingMsgs: (state) => state.pendingMsgs,
    currentConversation: (state) => state.currentConversation,
    numberUnreadConversations:(state)=> state.numberUnreadConversations,
    chatSettings: (state) => state.chatSettings,
    isReachChatIcon: (state)=> state.isReachChatIcon
  }
};

export default chat;
